console.log('Vite ⚡️ Rails')

import '../javascript/application'
